$('[data-header-search-icon]').on('click', function (){
    $(this)
        .toggleClass('fa-search')
        .toggleClass('fa-times');

    $('[data-header-nav]')
        .toggleClass('header__nav--search-open')
});
